module.exports = __webpack_public_path__ + "static/media/tuttoluce.aaac7b9a.webp";